import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const role = user?.role;
  let links = [];
  if (user) {
    if (role === "admin") {
      links = [
        { to: "/admin", label: "Admin" },
        { to: "/wardrobe", label: "Wardrobe" },
        { to: "/pair", label: "Pair" },
        { to: "/stylist", label: "Stylist" },
        { to: "/services", label: "Services" },
        { to: "/lookbook", label: "Lookbook" },
      ];
    } else if (role === "owner") {
      links = [
        { to: "/owner", label: "Studio" },
        { to: "/wardrobe", label: "Wardrobe" },
        { to: "/pair", label: "Pair" },
        { to: "/stylist", label: "Stylist" },
        { to: "/services", label: "Services" },
        { to: "/lookbook", label: "Lookbook" },
      ];
    } else {
      links = [
        { to: "/wardrobe", label: "Wardrobe" },
        { to: "/pair", label: "Pair" },
        { to: "/stylist", label: "Stylist" },
        { to: "/services", label: "Services" },
        { to: "/lookbook", label: "Lookbook" },
      ];
    }
  }

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-50 border-b border-white/10 backdrop-blur-xl"
      style={{ backgroundColor: "rgba(5,5,5,0.7)" }}
      data-testid="main-navbar"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 h-[74px] flex items-center justify-between">
        <Link to={user ? "/wardrobe" : "/"} className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="w-3 h-3 bg-volt inline-block group-hover:rotate-45 transition-transform" />
          <span className="font-display text-xl font-semibold uppercase tracking-tight leading-none">
            Eternal<span className="text-volt">/</span>Pairing
          </span>
        </Link>

        {user && (
          <nav className="hidden md:flex items-center gap-9">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={`overline ep-btn hover:text-white ${
                  location.pathname === l.to ? "text-volt" : "text-epsub"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        )}

        <div className="flex items-center gap-4">
          {user ? (
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              className="ep-btn flex items-center gap-2 text-xs font-mono-accent uppercase tracking-widest px-4 py-2.5 border border-white/20 hover:border-white hover:bg-white hover:text-black"
            >
              <LogOut size={14} strokeWidth={2} /> Sign out
            </button>
          ) : (
            <div className="flex items-center gap-4">
              <Link to="/login" data-testid="nav-login" className="overline text-epsub hover:text-white ep-btn">
                Sign in
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="ep-btn text-xs font-bold uppercase tracking-widest px-5 py-2.5 bg-volt text-black hover:bg-volt-hover"
              >
                Get Started
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
